export const breakpoints = [
  { width: 550, breakpoint: 'xs', device: 'mobile' },
  { width: 750, breakpoint: 'sm', device: 'mobile' },
  { width: 880, breakpoint: 'md', device: 'tablet' },
  { width: 1024, breakpoint: 'xs', device: 'tablet' },
  { width: 1280, breakpoint: 'xs', device: 'desktop' },
  { width: 1000000, breakpoint: 'xs', device: 'desktop' },
];

export const findCurrentBreakpoint = () => {
  const width = window.innerWidth;

  return breakpoints.find((breakpoint) => breakpoint.width >= width) || breakpoints[0];
};
